import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en_res from './languages/en.json';
import it_res from './languages/it.json';

export enum ELanguages {
    en = 'en',
    it = 'it',
}

export const languages = {
    [ELanguages.en]: 'English',
    [ELanguages.it]: 'Italian',
};

export const getLanguage = () => window.localStorage.getItem(options.lookupLocalStorage)!;

export type TLanguages = keyof typeof languages;

const resources = {
    en: {
        translation: en_res,
    },
    it: {
        translation: it_res,
    },
};

const options = {
    order: ['localStorage', 'navigator'],
    lookupLocalStorage: 'i18nextLng',
};

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init(
        {
            resources,
            fallbackLng: ELanguages.en,
            debug: true,
            detection: options,
            interpolation: {
                escapeValue: false,
            },
        },
        () => !resources[getLanguage() as TLanguages] && i18n.changeLanguage(ELanguages.en),
    );

export const changeLanguage = (language: TLanguages) => i18n.changeLanguage(language);

export default i18n;
